<template>
	<Row
		@click.native="$emit('update:isOpen', !isOpen)"
		class="flex-align-center accordion-header pl-[5px] pr-[9px] py-1 flex-justify-space-between"
	>
		<Row class="flex-align-center">
			<component v-if="collapsedModeNavButtonItem?.iconComponent" :is="collapsedModeNavButtonItem.iconComponent" class="mr-[10px]" />
			<h5 class="accordion-title">{{ title }}</h5>
			<v-icon :class="{ rotate: !isOpen }" class="ml-1 chevron">mdi-chevron-down</v-icon>
			<component v-if="titleSuffixComponent?.component" :is="titleSuffixComponent.component" :class="titleSuffixComponent.class" />
		</Row>
		<Row class="items-center">
			<AppTooltip v-if="createNewConfig" :disabled="!createNewConfig.tooltipText" :text="createNewConfig.tooltipText">
				<Col @click.native.stop="createNewConfig.createNew" class="create-new-button flex-centerize">
					<SIcon name="create-new-placement-plus" />
				</Col>
			</AppTooltip>
			<PinButton :tooltipPosition="'top'" :isPinned="true" tooltipText="Un pin" class="ml-[6px]" @click.native.stop="unPinNotifications" />
		</Row>
	</Row>
</template>
<script>
import CreateAndManageService from '../ManageAndCreate/create-and-manage-service';
import PinButton from '@/components/ProjectMenu/PinButton.vue';
import { setIsNotificationsPinned } from '@/store/modules/appLayout/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import NavigationButton from '@/views/AppLayout/AppNavigation/common/NavigationButton.vue';
export default {
	name: 'NavigationAccordionHeader',
	components: {
		PinButton,
		NavigationButton,
	},
	props: {
		to: { type: Function },
		title: { type: String },
		isOpen: { type: Boolean },
		sections: { type: Array },
		settings: { type: Object },
		createNewConfig: { type: Object },
		titleSuffixComponent: { type: Object },
		additionalItemSuffix: { type: Object },
		collapsedModeNavButtonItem: { type: Object },
	},
	computed: {
		isRouteActive() {
			return CreateAndManageService.isRouteOrChildOfRoute(this.$route, this.collapsedModeNavButtonItem.routeName);
		},
	},
	methods: {
		...mapActionsShorthand({ setIsNotificationsPinned }),
		unPinNotifications() {
			this.setIsNotificationsPinned({ isPinned: false });
		},
	},
};
</script>
<style lang="scss" scoped>
.create-new-button {
	height: 14px;
	width: 14px;
	cursor: pointer;
	border-radius: 50%;
	&.active,
	&:hover {
		background: #f2f2f2;
		border: 1px solid var(--border-color);
	}
}
.accordion-title {
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-size: 13px;
	font-weight: 400;
}
.chevron {
	font-size: 20px;
	color: #7c828d;
	transition: var(--transition-time);
	&.rotate {
		transform: rotate(-180deg);
	}
}
.accordion-header {
	cursor: pointer;
	border-radius: 7px;
	transition: var(--transition-time);
	&:hover {
		background: #e7e8f980;
	}
}
</style>
